import { render, staticRenderFns } from "./InvitationLinkExpired.vue?vue&type=template&id=c577cc86"
import script from "./InvitationLinkExpired.vue?vue&type=script&lang=js"
export * from "./InvitationLinkExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports